import {FullGameFetchHandler} from "../../../core/handlers/full-game.fetch-handler";

export class ScoreboardWidgetFetchHandler extends FullGameFetchHandler {}
